import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { EditVendorDialog } from './EditVendorDialog.jsx';
import BCP from '../../../common/section_bcp/DM_BCP.js';
/**
 * @param {AlternateMVLinkedRenderer.propTypes} props
 * @return {JSX.Element}
 */

export function AlternateMVLinkedRenderer(props) {
    let { disabled, buttonSx, context, bcpRequest, values, action, setNewCellValue,
        apiRef, canAcceptOrReject, refreshLine,
        currentColumnName, deleteElementsForColumns } = props;
    const [refreshMe, setRefreshMe] = useState(false);
    const plantID = bcpRequest.get(BCP.plantIdProp)
    const materialId = bcpRequest.get(BCP.materialIdProp);
    const closePopup = () => {
        setRefreshMe(false)
    }
    return (
        <>
            <Button
                variant={'text'}
                disabled={disabled}
                sx={buttonSx}
                onClick={() => {
                    setRefreshMe(true)
                }}
            >
                {action}
            </Button>
            {refreshMe && <EditVendorDialog
                plantID={plantID}
                materailId={materialId}
                setRefreshMe={setRefreshMe}
                apiRef={apiRef}
                values={values}
                refreshMe={refreshMe}
                closePopup={() => closePopup()}
                context={context}
                currentColumnName={currentColumnName}
                canAcceptOrReject={canAcceptOrReject}
                bcpRequest={bcpRequest}
                refreshLine={refreshLine}
                setNewCellValue={setNewCellValue}
                deleteElementsForColumns={deleteElementsForColumns}
            />
            }
        </>
    )
}
AlternateMVLinkedRenderer.propTypes = {
    context: PropTypes.object.isRequired,
    bcpRequest: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    buttonSx: PropTypes.object,
    apiRef: PropTypes.object,
    action: PropTypes.string,
    setNewCellValue: PropTypes.func,
    deleteElementsForColumns: PropTypes.func
};
